import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';
import { device } from '../../../../shared/styles/device';

const GridTwoCol = styled.section`
  display: grid;
  max-height: 100vh;
  height: 900px;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: 900px;

  @media ${device.tablet} {
    grid-template-columns: minmax(0, 2fr)  minmax(0, 3fr);
  }
`;
const HeroImageWrapper = styled.div`
  display: none;
  visibility: hidden;

  @media ${device.tablet} {
    visibility: visible;
    background-color: #18191F;
    display: flex;
    align-items: flex-start;
    position: relative;
    max-height: 100vh;
    border-radius: 0 0 64px 0;

    .hero-img {
      height: 100%;
      width: 100%;
      border-radius: 0 0 64px 0;
    }
  }
`;
const HeroTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-height: 100vh;
    margin-left: 16px;
    max-width: 100%;
    margin-right: 16px;
  
    @media ${device.tablet} {
      margin-left: 42px;
      max-width: 576px;
      align-items: flex-start;
    }

    @media ${device.laptop} {
      max-width: 653px;
    }
`;

interface HeadlineProps {
  readonly primary?: boolean;
};

const Headline = styled.h1<HeadlineProps>`
    color: ${props => props.primary ? props.theme.colors.primary : props.theme.colors.fontBlack};
    line-height: 92px;
    margin-bottom: ${props => props.primary ? '32px' : '0px'};
    margin-top: 0;
    text-align: left;

    @media(max-width: 768px) {
        font-size: 36px;
        letter-spacing: -0.1rem;
        line-height: normal;
        margin-bottom: ${props => props.primary ? '32px' : '0px'};
    }
`;
const HeroText = styled.p`
    color: ${props => props.theme.colors.fontBlack};
    margin-bottom: 32px;
    margin-top: 0;
    font-size: 19px;
    line-height: 27px;
    font-weight: 400;
    letter-spacing: -0.01em;
    text-align: left;

  @media ${device.tablet} {
    font-size: 19px;
    line-height: 27px;
    font-weight: 400;
    letter-spacing: -0.01em;
  }
`;

export const HeroIntro = () => {
  return (
    <GridTwoCol>
      <HeroImageWrapper>
        <Image
          src="/images/aboutus/sme.jpg"
          alt="Stell-Mich-Ein Treffen Meeting"
          layout='fill'
          quality={100}
          className="hero-img"
          loading="eager"
          objectFit='cover'
          priority={true}
        />
      </HeroImageWrapper>
      <HeroTextWrapper>
        <Headline>Über das</Headline>
        <Headline primary>STELL-MICH-EIN</Headline>
        <HeroText>
          Das STELL-MICH-EIN hatte seine Geburtsstunde im Berliner KommunikationsFORUM e.V. Seit 2012 wurde das damals einzige Speed-Recruiting der Kommunikationsbranche zu unterschiedlichen Events und Anlässen von wechselnden Teams organisiert. So waren wir zu Gast auf ADC Kongressen, Hochschultagen und Messen.
          <br /> <br />
          Als Ende 2016 das Berliner KommunikationsFORUM e.V. aufgelöst wurde, waren es die Agenturen und Bewerber*innen, die eine Weiterführung forderten. Steven, langjähriger Vorstand des Vereins, brachte das Format schließlich zur SCM – School for Communication and Management. In den letzten Jahren haben wir das Recruiting professionalisiert, sind in immer mehr deutschen Städten aktiv und haben digitale Formate entwickelt.
        </HeroText>
      </HeroTextWrapper>

    </GridTwoCol>
  )
}
